import { CALL_API } from 'redux-api-middleware';
import { isObject } from 'lodash';

const genericHeaders = (store) => next => action => {
  if (action && isObject(action[CALL_API])) {
    const apiRequest = action[CALL_API];
    apiRequest.headers = apiRequest.headers || {};
    apiRequest.headers = {
      'Content-Type': 'application/json; charset=utf-8',
      'Cache-Control': 'no-cache',
      ...apiRequest.headers
    };
    //let the browser generate a proper Content-Type for this upload
    if(apiRequest.requestType == 'upload') {
      delete apiRequest.headers['Content-Type'];
    }
    if(apiRequest.requestType)
      delete apiRequest.requestType; //need to delete this otherwise something breaks on it later
    apiRequest.headers['Authorization'] = `Bearer ${store.getState().user.profile.token}`;
    //apiRequest.credentials = 'include';
  } else if (!action) action = {type: ""};


  return next(action);
};

export default genericHeaders;
